import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {Role} from '../../models/role';
import {ISerializable} from 'cerialize';

export const RoleTransformer: ISerializable = {
  Serialize(value: Role): string {
    return snakify(Role[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return Role[valueName];
    }
    return Role.Gast;
  }
};
